export const DEFAULT_LIST_HEIGHT = 320;
export const DEFAULT_SEARCH_DELAY = 300;
export const TAB_ALL = 'all';
export const TAB_SELECTED = 'selected';
